//
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authActions, authSelectors, authTypes } from 'app-components/flux/auth';
import { datasetsActions, datasetsSelectors } from 'app-components/flux/datasets';
import { preferencesV2Actions, preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import { useFetchOnce } from 'app-components/hooks/utils';

import { getShareAcceptData, removeShareAcceptData } from 'data/app/helpers';

const useDatasetHandler = (props) => {
  const { authNotNeeded } = props;
  const dispatch = useDispatch();

  useFetchOnce(datasetsActions.getDatasets, datasetsSelectors, false, true);
  const entitledDatasetsLoadPending = useSelector(datasetsSelectors.getEntitledDatasetsLoadPending);

  // useFetchOnce(preferencesV2Actions.getPreferencesV2, preferencesV2Selectors, false, true); // TODO: QCS fix user scope
  useFetchOnce(preferencesV2Actions.getPreferencesV2, preferencesV2Selectors, false, false);

  const datasetsById = useSelector(datasetsSelectors.getEntitledDatasets);
  const datasetId = useSelector(authSelectors.getDatasetId);

  // If we have loaded datasets and one has not yet been selected, then select dataset to load
  //
  useEffect(() => {
    if (datasetsById.size && !datasetId && !authNotNeeded && !entitledDatasetsLoadPending) {
      let dataset = null;
      const shareAcceptData = getShareAcceptData();
      if (shareAcceptData) {
        dataset = datasetsById.get(shareAcceptData.datasetId);
        removeShareAcceptData();
      }
      if (dataset) {
        dispatch(authActions.authSelectDataset(authTypes.AuthSelectDatasetPayload({ dataset, userChoice: true })));
      } else {
        dispatch(authActions.authSelectDatasetAuto({ reload: true, location: window.location.href }));
      }
    }
  }, [datasetsById, datasetId, authNotNeeded, dispatch, entitledDatasetsLoadPending]);
};

export default useDatasetHandler;
